/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import window from 'ember-window-mock';

import ReleaseNotificationService from 'cio/services/release-notification';

export default class CioReleaseNotificationComponent extends Component {
  'data-test-release-notification-modal' = true;

  @service releaseNotification!: ReleaseNotificationService;

  @action
  reload() {
    this.releaseNotification.set('showModal', false);
    window.location.reload();
  }
}
